import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { stage } from "../../assets/globalHelpers";
import "../../assets/css/argon-dashboard-react.css"
import "../../assets/css/diagramms/queueDiagram.css"
import { useLanguage } from "context/LanguageProvider";
import { stagesNames } from "../translation.js"
import { useDarkMode } from "context/DarkModeProvider";
import axiosInstance from "apiHandles/axiosInstance"; // ✅ Πρόσθεσε

function QueueDiagram({ items, finalStages, onItemClick }) {
  const colorScheme = {
    primary: '#ef4444',
    secondary: '#dc2626',
    accent: '#fecaca'
  };

  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { darkMode } = useDarkMode();
  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  const handleItemClick = (index) => {
    if (onItemClick) {
      onItemClick(index);
      return;
    }

    const stage = finalStages[index];
    if (!stage) {
      console.error("No stage found at index:", index);
      return;
    }

    // ✅ Αποθηκεύουμε ΜΟΝΟ το ID
    localStorage.setItem("stageLocation", stage.name);
    localStorage.setItem("selectedStageId", stage.id);  // ✅ Μόνο ID

    navigate("/admin/index");
  };

  return (
    <div className="queueDiagramContainer">
      {/* Ουρά */}
      <div className="queueDiagramSpace">
        {items.map((item, index) => (
          <div key={index} className="queueItem">
            {/* Ετικέτες FRONT και REAR */}
            {index === 0 && (
              <div
                className="queueLabel queueLabelFront"
                style={{
                  color: darkMode ? "#fff" : colorScheme.primary,
                }}
              >
                FRONT
              </div>
            )}
            {index === items.length - 1 && (
              <div
                className="queueLabel queueLabelRear"
                style={{
                  color: darkMode ? "#fff" : colorScheme.primary,
                }}
              >
                REAR
              </div>
            )}

            {/* Στοιχείο ουράς */}
            <div
              className="queueItemBox"
              style={{
                background: `linear-gradient(135deg, ${colorScheme.primary}15 0%, ${colorScheme.secondary}10 100%)`,
                backdropFilter: 'blur(10px)',
                border: `1px solid ${colorScheme.primary}30`,
                transform: hoveredIndex === index
                  ? "scale(1.05) translateY(-4px)"
                  : "scale(1)",
                boxShadow: hoveredIndex === index
                  ? `0 0px 10px ${colorScheme.primary}40, 0 0 0 1px ${colorScheme.primary}20`
                  : `none`,
                cursor: 'pointer',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => handleItemClick(index)}
            >
              {/* Animated background overlay για hover effect */}
              <div
                style={{
                  position: 'absolute',
                  inset: '0',
                  background: `linear-gradient(135deg, ${colorScheme.primary}${hoveredIndex === index ? '25' : '15'} 0%, ${colorScheme.secondary}${hoveredIndex === index ? '20' : '10'} 100%)`,
                  transition: 'all 0.3s ease',
                  borderRadius: 'inherit',
                }}
              />

              <div
                className="queueItemText"
                style={{
                  color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
                  background: `linear-gradient(135deg, ${colorScheme.primary} 0%, ${colorScheme.secondary} 100%)`,
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                }}
              >
                {selLanguage ? stagesNames[item.toLowerCase()] : item}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Βάση */}
      <div
        className="queueBase"
        style={{
          width: `calc(90% - ${items.length * 2}px)`,
          maxWidth: '1200px',
        }}
      />

      {/* Δείκτες index κάτω από τη βάση */}
      <div className="queueIndexContainer">
        {items.map((_, index) => (
          <div
            key={`index-${index}`}
            className="queueIndex"
            style={{
              color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
              fontWeight: hoveredIndex === index ? "bold" : "600",
            }}
          >
            [{index}]
          </div>
        ))}
      </div>
    </div>
  );
}

export default QueueDiagram;